
<!-- Toast global (sem key): fallback do interceptor pra 401 inesperado, ver http.service.ts. -->
<p-toast></p-toast>

<!-- Aviso de nova versão publicada — sticky, some só com ação do usuário. Ver VersionCheckService. -->
<p-toast key="appUpdate" position="bottom-right" styleClass="app-update-host">
    <ng-template let-message pTemplate="message">
        <div class="app-update-toast" role="status">
            <span class="app-update-toast__icon" aria-hidden="true">
                <i class="pi pi-refresh"></i>
            </span>
            <div class="app-update-toast__body">
                <span class="app-update-toast__title">{{ message.summary }}</span>
                <span class="app-update-toast__detail">{{ message.detail }}</span>
            </div>
            <div class="app-update-toast__actions">
                <button type="button" class="app-update-toast__reload" (click)="reloadApp()">
                    {{ 'appUpdate.reload' | transloco }}
                </button>
                <button type="button" class="app-update-toast__dismiss" (click)="dismissAppUpdate()"
                        [attr.aria-label]="'appUpdate.dismiss' | transloco">
                    <i class="pi pi-times" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </ng-template>
</p-toast>

<router-outlet></router-outlet>
